export const generateColorFromString = (str: string) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  // Extract RGB values and limit the brightness
  let r = (hash >> 16) & 0xff;
  let g = (hash >> 8) & 0xff;
  let b = hash & 0xff;

  // Adjust colors to avoid very light shades
  const brightnessThreshold = 200; // Max brightness to avoid light colors
  const scaleFactor = Math.min(brightnessThreshold / Math.max(r, g, b, 1), 1);

  r = Math.floor(r * scaleFactor);
  g = Math.floor(g * scaleFactor);
  b = Math.floor(b * scaleFactor);

  return `#${r.toString(16).padStart(2, "0")}${g
    .toString(16)
    .padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
};
